<template>
  <g
    id="Headlamp"
    v-on:click="changeSeverity('frontHeadLamp')"
    :class="severityClass"
  >
    <path
      class="cls-735"
      d="M662.55,220.13c0-1.56-1.27-2.83-2.83-2.83-.9,0-1.69,.43-2.21,1.08-2.29-2.16-5.38-3.48-8.79-3.48-7.05,0-12.77,5.68-12.77,12.68s5.72,12.68,12.77,12.68,12.77-5.68,12.77-12.68c0-1.68-.33-3.29-.93-4.76,1.15-.36,1.99-1.42,1.99-2.69Z"
    />
    <g>
      <circle class="cls-201" cx="636.39" cy="219.26" r="2.83" />
      <circle class="cls-375" cx="636.39" cy="219.26" r="2.67" />
      <path
        class="cls-879"
        d="M638.76,219.26c0-1.31-1.06-2.38-2.38-2.38s-2.38,1.06-2.38,2.38,1.06,2.38,2.38,2.38,2.38-1.06,2.38-2.38Z"
      />
      <circle class="cls-878" cx="636.39" cy="219.26" r="2.01" />
      <circle class="cls-787" cx="636.39" cy="219.26" r="2.01" />
    </g>
    <g>
      <circle class="cls-201" cx="659.1" cy="219.26" r="2.83" />
      <circle class="cls-375" cx="659.1" cy="219.26" r="2.67" />
      <path
        class="cls-888"
        d="M656.73,219.26c0-1.31,1.06-2.38,2.38-2.38s2.38,1.06,2.38,2.38-1.06,2.38-2.38,2.38-2.38-1.06-2.38-2.38Z"
      />
      <circle class="cls-897" cx="659.1" cy="219.26" r="2.01" />
      <circle class="cls-786" cx="659.1" cy="219.26" r="2.01" />
    </g>
    <g>
      <ellipse class="cls-898" cx="647.74" cy="226.49" rx="12.77" ry="12.68" />
      <path
        class="cls-166"
        d="M659.1,226.49c0,6.2-5.08,11.23-11.36,11.23s-11.36-5.03-11.36-11.23c0-1.77,.41-3.45,1.15-4.94,1.85-3.73,5.73-6.29,10.21-6.29s8.15,2.43,10.05,6c.83,1.56,1.31,3.34,1.31,5.23Z"
      />
      <g>
        <path
          class="cls-3"
          d="M636.73,229.19c-.09-1.8-.09-3.61,0-5.41-.22,.87-.34,1.77-.34,2.7s.13,1.84,.34,2.7Z"
        />
        <path
          class="cls-1000"
          d="M636.73,229.19c.09,.37,.2,.73,.33,1.09-.17-2.52-.17-5.06,0-7.58-.13,.36-.24,.72-.33,1.09-.09,1.8-.09,3.61,0,5.41Z"
        />
        <path
          class="cls-3"
          d="M637.9,232.08c.1,.17,.2,.34,.31,.5-.4-4.04-.4-8.14,0-12.18-.11,.16-.21,.33-.31,.5-.35,3.72-.35,7.47,0,11.18Z"
        />
        <path
          class="cls-1000"
          d="M638.21,232.58c.1,.15,.2,.29,.3,.43-.45-4.33-.45-8.72,0-13.04-.1,.14-.2,.28-.3,.43-.4,4.04-.4,8.14,0,12.18Z"
        />
        <path
          class="cls-3"
          d="M639.27,233.94c.1,.11,.2,.22,.3,.33-.57-5.15-.57-10.41,0-15.56-.1,.11-.2,.22-.3,.33-.54,4.94-.54,9.97,0,14.91Z"
        />
        <path
          class="cls-1000"
          d="M639.57,218.7c-.57,5.15-.57,10.41,0,15.56,.1,.1,.19,.2,.29,.29-.6-5.34-.6-10.81,0-16.15-.1,.1-.2,.19-.29,.29Z"
        />
        <path
          class="cls-3"
          d="M640.58,235.2c.09,.07,.18,.14,.28,.2-.65-5.89-.65-11.94,0-17.83-.09,.07-.19,.13-.28,.2-.64,5.76-.64,11.67,0,17.43Z"
        />
        <path
          class="cls-1000"
          d="M640.86,235.4c.09,.07,.18,.14,.27,.2-.65-6.02-.65-12.22,0-18.24-.09,.07-.18,.13-.27,.2-.65,5.89-.65,11.95,0,17.83Z"
        />
        <path
          class="cls-3"
          d="M641.81,236.05c.09,.05,.18,.11,.26,.16-.64-6.41-.64-13.04,0-19.45-.09,.05-.18,.11-.26,.16-.65,6.31-.65,12.82,0,19.13Z"
        />
        <path
          class="cls-1000"
          d="M642.08,236.21c.09,.05,.17,.11,.26,.16-.63-6.51-.63-13.25,0-19.76-.09,.05-.17,.11-.26,.16-.64,6.41-.64,13.04,0,19.45Z"
        />
        <path
          class="cls-3"
          d="M643,236.68c.09,.04,.17,.08,.26,.12-.58-6.79-.58-13.85,0-20.63-.09,.04-.17,.08-.26,.12-.6,6.71-.6,13.68,0,20.39Z"
        />
        <path
          class="cls-1000"
          d="M643.25,236.8c.08,.04,.17,.07,.25,.1-.56-6.85-.56-13.98,0-20.83-.08,.03-.17,.06-.25,.1-.58,6.79-.58,13.85,0,20.63Z"
        />
        <path
          class="cls-3"
          d="M644.15,237.13c.08,.03,.17,.06,.25,.09-.47-7.05-.47-14.42,0-21.47-.09,.03-.17,.06-.25,.09-.5,7-.5,14.3,0,21.3Z"
        />
        <path
          class="cls-1000"
          d="M644.4,237.22c.08,.02,.17,.04,.25,.06-.44-7.09-.44-14.5,0-21.6-.08,.02-.17,.04-.25,.06-.47,7.05-.47,14.42,0,21.47Z"
        />
        <path
          class="cls-3"
          d="M645.28,237.45c.08,.02,.16,.04,.25,.05-.33-7.23-.33-14.8,0-22.03-.08,.02-.16,.04-.25,.05-.36,7.2-.36,14.72,0,21.92Z"
        />
        <path
          class="cls-1000"
          d="M645.53,237.5c.08,.02,.16,.02,.25,.04-.3-7.26-.3-14.85,0-22.1-.08,.01-.16,.02-.25,.04-.33,7.23-.33,14.8,0,22.03Z"
        />
        <path
          class="cls-3"
          d="M646.4,237.63c.08,0,.16,.02,.24,.03-.17-7.34-.17-15.02,0-22.35-.08,0-.16,.02-.24,.03-.21,7.32-.21,14.97,0,22.29Z"
        />
        <path
          class="cls-1000"
          d="M646.64,237.66c.08,0,.16,0,.24,.01-.13-7.34-.13-15.03,0-22.38-.08,0-.16,0-.24,.01-.17,7.34-.17,15.02,0,22.35Z"
        />
        <path
          class="cls-3"
          d="M647.5,237.7c.08,0,.16,.01,.24,.01v-22.46c-.08,0-.16,.01-.24,.01-.04,7.36-.04,15.07,0,22.44Z"
        />
        <path
          class="cls-1000"
          d="M647.74,237.72c.08,0,.16-.01,.24-.01,.04-7.36,.04-15.07,0-22.44-.08,0-.16-.01-.24-.01v22.46Z"
        />
        <path
          class="cls-3"
          d="M648.6,237.67c.08,0,.16,0,.24-.01,.17-7.34,.17-15.02,0-22.35-.08,0-.16,0-.24-.01,.13,7.34,.13,15.03,0,22.38Z"
        />
        <path
          class="cls-1000"
          d="M648.85,237.66c.08,0,.16-.02,.24-.03,.21-7.32,.21-14.97,0-22.29-.08,0-.16-.02-.24-.03,.17,7.34,.17,15.02,0,22.35Z"
        />
        <path
          class="cls-3"
          d="M649.71,237.54c.08-.01,.17-.02,.25-.04,.33-7.23,.33-14.8,0-22.03-.08-.02-.16-.02-.25-.04,.3,7.26,.3,14.85,0,22.1Z"
        />
        <path
          class="cls-1000"
          d="M649.96,237.5c.08-.02,.16-.04,.25-.05,.36-7.2,.36-14.72,0-21.92-.08-.02-.16-.04-.25-.05,.33,7.23,.33,14.8,0,22.03Z"
        />
        <path
          class="cls-3"
          d="M650.84,237.29c.08-.02,.17-.04,.25-.06,.47-7.05,.47-14.42,0-21.47-.08-.02-.17-.04-.25-.06,.44,7.09,.44,14.5,0,21.6Z"
        />
        <path
          class="cls-1000"
          d="M651.09,237.22c.09-.03,.17-.06,.25-.09,.5-7,.5-14.3,0-21.3-.08-.03-.17-.06-.25-.09,.47,7.05,.47,14.42,0,21.47Z"
        />
        <path
          class="cls-3"
          d="M651.98,236.9c.08-.03,.17-.06,.25-.1,.58-6.79,.58-13.85,0-20.63-.08-.04-.17-.07-.25-.1,.56,6.85,.56,13.98,0,20.83Z"
        />
        <path
          class="cls-1000"
          d="M652.24,236.8c.09-.04,.17-.08,.26-.12,.6-6.71,.6-13.68,0-20.39-.09-.04-.17-.09-.26-.12,.58,6.79,.58,13.85,0,20.63Z"
        />
        <path
          class="cls-3"
          d="M653.15,236.37c.09-.05,.17-.11,.26-.16,.64-6.41,.64-13.04,0-19.45-.09-.05-.17-.11-.26-.16,.63,6.51,.63,13.25,0,19.76Z"
        />
        <path
          class="cls-1000"
          d="M653.41,236.21c.09-.05,.18-.11,.26-.16,.65-6.31,.65-12.82,0-19.13-.09-.05-.18-.11-.26-.16,.64,6.41,.64,13.04,0,19.45Z"
        />
        <path
          class="cls-3"
          d="M654.36,235.61c.09-.07,.18-.13,.27-.2,.65-5.89,.65-11.94,0-17.83-.09-.07-.18-.14-.27-.2,.65,6.02,.65,12.22,0,18.24Z"
        />
        <path
          class="cls-1000"
          d="M654.63,235.4c.09-.07,.19-.13,.28-.2,.64-5.76,.64-11.67,0-17.43-.09-.07-.18-.14-.28-.2,.65,5.89,.65,11.94,0,17.83Z"
        />
        <path
          class="cls-3"
          d="M655.63,218.41c.6,5.34,.6,10.81,0,16.15,.1-.1,.2-.19,.29-.29,.57-5.15,.57-10.41,0-15.56-.1-.1-.19-.2-.29-.29Z"
        />
        <path
          class="cls-1000"
          d="M655.92,234.27c.1-.11,.2-.22,.3-.33,.54-4.94,.54-9.97,0-14.91-.1-.11-.2-.22-.3-.33,.57,5.15,.57,10.41,0,15.56Z"
        />
        <path
          class="cls-3"
          d="M656.98,233.01c.1-.14,.2-.28,.3-.43,.4-4.04,.4-8.14,0-12.18-.1-.15-.2-.29-.3-.43,.45,4.33,.45,8.72,0,13.04Z"
        />
        <path
          class="cls-1000"
          d="M657.28,232.58c.11-.16,.21-.33,.31-.5,.35-3.72,.35-7.47,0-11.18-.1-.17-.2-.34-.31-.5,.4,4.04,.4,8.14,0,12.18Z"
        />
        <path
          class="cls-3"
          d="M658.43,230.28c.13-.36,.24-.72,.33-1.09,.09-1.8,.09-3.61,0-5.41-.09-.37-.2-.73-.33-1.09,.17,2.52,.17,5.06,0,7.58Z"
        />
        <path
          class="cls-1000"
          d="M658.76,229.19c.22-.87,.34-1.77,.35-2.7h0c0-.94-.13-1.84-.35-2.7,.09,1.8,.09,3.61,0,5.41Z"
        />
      </g>
      <path
        class="cls-736"
        d="M654.12,217.19s.02,0,.02,.01c-.03-.02-.07-.04-.1-.06-.17-.11-.35-.22-.53-.33-.06-.04-.13-.07-.2-.11-.16-.09-.33-.18-.5-.26-.08-.04-.16-.08-.25-.12-.16-.07-.31-.14-.47-.21-.1-.04-.2-.08-.3-.12-.14-.05-.29-.11-.44-.15-.12-.04-.23-.08-.35-.11-.13-.04-.27-.07-.4-.11-.13-.03-.27-.07-.4-.1-.12-.03-.24-.05-.35-.07-.16-.03-.31-.06-.47-.08-.09-.01-.18-.02-.27-.03-.45-.05-.91-.09-1.37-.09-.06,0-.12,0-.19,0-.27,0-.54,.02-.81,.04-.09,0-.19,.02-.28,.03-.24,.03-.49,.06-.73,.1-.13,.02-.25,.04-.38,.07-.31,.07-.61,.14-.91,.23-.1,.03-.2,.07-.31,.1-.22,.07-.44,.15-.65,.24-.1,.04-.19,.08-.29,.12-.29,.13-.59,.26-.87,.41,0,0,0,0,0,0-.29,.16-.57,.33-.85,.51-.07,.04-.13,.09-.19,.13-.24,.16-.46,.33-.69,.51-.04,.03-.07,.06-.11,.09-.26,.22-.51,.44-.76,.68-.02,.02-.05,.05-.07,.07-.22,.22-.42,.44-.62,.68-.04,.04-.07,.08-.11,.12-.43,.52-.81,1.08-1.14,1.67-.03,.05-.05,.1-.08,.15-.06,.11-.12,.22-.18,.33,0,0,.01,0,.03-.02-.75,1.5-1.18,3.17-1.18,4.96,0,4.19,2.32,7.83,5.76,9.76-3-2.02-4.96-5.42-4.96-9.28,0-.02,0-.05,0-.07,.02-3.74,2.49-7.06,6.04-8.27,4.06-1.39,9.66-1.87,14.58,2.76v-.12c-.87-1.64-2.14-3.03-3.68-4.06Z"
      />
      <path
        class="cls-943"
        d="M647.74,228.5c4.5,0,8.52-1.4,11.23-3.59-.78-5.45-5.5-9.65-11.23-9.65s-10.46,4.2-11.23,9.65c2.71,2.2,6.73,3.59,11.23,3.59Z"
      />
      <path
        class="cls-900"
        d="M658.75,221.64h-.53c-.18,0-.34-.1-.41-.26-1.9-3.61-5.69-6.07-10.05-6.07s-8.16,2.46-10.05,6.07c-.08,.16-.24,.26-.41,.26h-.53c1.91-4.17,6.12-7.06,11-7.06s8.95,2.8,10.9,6.86c.03,.07,.07,.14,.1,.21Z"
      />
      <path
        class="cls-405"
        d="M658.35,221.64h-.13c-.18,0-.34-.1-.41-.26-1.9-3.61-5.69-6.07-10.05-6.07s-8.16,2.46-10.05,6.07c-.08,.16-.24,.26-.41,.26h-.13c1.88-3.96,5.92-6.7,10.6-6.7s8.72,2.74,10.6,6.7Z"
      />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
